import { useAtom, useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { reject } from '~/utils'

import {
  columnsDiffsAtom,
  countColumnKeysAtom,
  isTabulatedAtom,
} from '../atoms'

export const useOmitNonTabulatedColumnsFromDiff = () => {
  const isTabulated = useAtomValue(isTabulatedAtom)
  const [columnsDiffs, setColumnsDiffs] = useAtom(columnsDiffsAtom)
  const countColumnKeys = useAtomValue(countColumnKeysAtom)

  React.useEffect(() => {
    if (!isTabulated) {
      return
    }

    const notTabulatedCountColumnKeys = R.pipe(
      columnsDiffs,
      R.flat(),
      R.filter(R.isNot(R.isIncludedIn(countColumnKeys))),
    )
    if (0 < notTabulatedCountColumnKeys.length) {
      setColumnsDiffs(
        reject(
          (columnsDiff) =>
            0 < R.intersection(columnsDiff, notTabulatedCountColumnKeys).length,
        ),
      )
    }
  }, [columnsDiffs, isTabulated, setColumnsDiffs, countColumnKeys])
}
